import React, { memo, useRef, useState } from "react";
import { Handle, Position } from "react-flow-renderer";
import UserService from "../../services/UserService";
import { ReactComponent as AddItemIcon } from "../../assets/icons/add_box.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/close.svg";
import { ReactComponent as LoopAllIcon } from "../../assets/icons/loop_all.svg";
// import { ReactComponent as ListIcon } from '../../../assets/icons/list.svg'
import { ReactComponent as ListIcon } from "../../assets/icons/add.svg";
import { ReactComponent as CodeIcon } from "../../assets/icons/block.svg";

import Wizard from "../../domain/Devices/Wizards/Wizard";
import { useDevice, useDevices, useModels } from "../../Api/newSockets.api";

//@ts-ignore
export default memo(({ data }) => {
  const [deviceColor, setDeviceColor] = useState("");
  const [runtime, setRuntime] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [payload, setPayload] = useState(data);
  const [isEditingName, setIsEditingName] = useState(false);
  const [nodeName, setNodeName] = useState(data.block.name);

  const customNodeStyles = {
    block: {
      background: "#252d2f",
      color: "#a2a9a8",
      borderRadius: "5px",
      width: "fit-content",
      minWidth: "230px",
      //boxShadow: '-2px 1px 8px 1px #0f0f0f',
    },
    title: {
      margin: 0,
      fontSize: "14px",
      color: "#fff",
      fontFamily: "Catamaran",
      letterSpacing: "0.5px",
      padding: "10px",
      textAlign: "left" as "left",
    },
    subtitle: {
      fontSize: "11px",
      display: "block",
      marginTop: "-2px",
      color: "#e8e8e8",
    },
    inputsBlock: {
      padding: "15px",
      fontSize: "12px",
    },
    inputBlock: {
      marginBottom: "10px",
    },
    input: {
      padding: "4px 7px 4px 5px",
      borderRadius: "3px",
      maxWidth: "7rem",
      border: "1px solid #d5dbdc",
      fontSize: "12px",
      color: "#d5dbdc",
      background: "#252d2f",
      //color: 'lightgrey'
    },
    scope: {
      padding: "15px",
      paddingTop: "0",
      display: "flex",
      justifyContent: "space-between",
    },
    label: {
      paddingRight: "5px",
      // display:'block',
      fontSize: "12px",
      color: "#9ca9ae",
    },
    blockTitle: {
      fontSize: "10px",
      display: "block",
      marginTop: "3px",
      color: "#e8e8e8",
      padding: "10px 15px",
    },
    handleTopCenter: {
      width: "30%",
      height: "20px",
      borderTopRightRadius: "5px",
      borderTopLeftRadius: "5px",
      borderBottomLeftRadius: "unset",
      borderBottomRightRadius: "unset",
      top: "-25px",
      border: "unset",
      background: "#586565",
    },
    handleBottomCenter: {
      width: "30%",
      height: "20px",
      borderBottomRightRadius: "5px",
      borderBottomLeftRadius: "5px",
      borderTopLeftRadius: "unset",
      borderTopRightRadius: "unset",
      bottom: "-25px",
      border: "unset",
      background: "#586565",
    },
  };
  var deviceColors = [
    "saddlebrown",
    "darkolivegreen",
    "darksalmon",
    "mediumaquamarine",
  ];


  const { getDevicesByDeviceType } = useDevices();
  const { models } = useModels();
  const { devices } =
    data.block.deviceTypeId != null &&
    getDevicesByDeviceType(data.block.deviceTypeId);

  if (!data.block.deviceId && devices) {
    data.block.deviceId = parseInt(devices[0]?.id);
  }

  const saveToScope = (label) => {
    data.onScopeChange("scope." + label);
  };

  const onDelete = (id) => {
    data.onDeleteNode(id);
  };

  const onRunTimeChange = () => {
    console.log(data.block.runtime);

    if (data.block.runtime == 0) {
      data.block.runtime = 1;
    } else if (data.block.runtime == 1) {
      data.block.runtime = 0;
    }
    setRuntime(data.block.runtime);
  };

  const onAddVariable = () => {
    setModalOpen(true);
  };

  const onChange = (value, index) => {
    data.block.inputs[index].value = value;
  };

  const onDeviceChange = (e) => {
    data.block.deviceId = e.target.value;
  };

  const onEditCode = () => {
    if (data.onEditCode) {
      data.onEditCode(data.id, data.block);
    }
  };

  const handleNameClick = () => {
    setIsEditingName(true);
  };

  const handleNameChange = (e) => {
    setNodeName(e.target.value);
  };

  const handleNameBlur = () => {
    setIsEditingName(false);
    if (nodeName.trim() !== "") {
      data.block.name = nodeName;
    } else {
      setNodeName(data.block.name);
    }
  };

  const handleNameKeyDown = (e) => {
    if (e.key === "Enter") {
      e.target.blur();
    } else if (e.key === "Escape") {
      setNodeName(data.block.name);
      setIsEditingName(false);
    }
  };

  const setSelected = (device, data, key) => {
    if (key == 0) {
      data.block.deviceId = device.id;
      return true;
    }
    if (data.block.deviceId == device.id) {
      data.block.deviceId = device.id;
      return true;
    }
    return false;
  };
  return (
    <div style={customNodeStyles.block}>
      {/* <div style={{ border: `1px solid ${deviceColor}`, borderRadius: "5px" }}> */}
      <div style={{ borderRadius: "5px" }}>
        <Handle
          type="target"
          position={Position.Top}
          style={customNodeStyles.handleTopCenter}
        />
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #666d6e",
          }}
        >
          <img
            src={`/devicetypes/${data.block.deviceTypes?.icon || "undefined"}.svg`}
            style={{
              width: "2.5rem",
              height: "2.5rem",
              margin: "8px",
              marginRight: "0",
              padding: "7px",
              background: "#1a1f21",
              borderRadius: "4px",
            }}
          />
          <div style={customNodeStyles.title}>
            {isEditingName ? (
              <input
                type="text"
                value={nodeName}
                onChange={handleNameChange}
                onBlur={handleNameBlur}
                onKeyDown={handleNameKeyDown}
                autoFocus
                className="nodrag"
                style={{
                  background: "#1a1f21",
                  border: "1px solid #53bde4",
                  borderRadius: "3px",
                  color: "#fff",
                  fontSize: "14px",
                  padding: "2px 5px",
                  width: "100%",
                  outline: "none",
                  fontFamily: "Catamaran",
                  letterSpacing: "0.5px",
                }}
              />
            ) : (
              <div
                onClick={handleNameClick}
                style={{
                  cursor: "text",
                  padding: "2px 0",
                }}
                title="Click to rename"
              >
                {nodeName}
              </div>
            )}
            <span style={customNodeStyles.subtitle}>
              {data.block.deviceTypes?.name}
            </span>
          </div>
          {/* {
                    data.block.runtime == 0 ? <LoopAllIcon style={{ position: "absolute", top: "7",width: "20px", right: "10", fill: "#c7c7c7", cursor: "pointer" }} onClick={onRunTimeChange} />
                    : <LoopAllIcon style={{ position: "absolute", top: "7", right: "10", width: "20px", fill: "cyan", cursor: "pointer" }} onClick={onRunTimeChange} />

                } */}
          <CodeIcon
            onClick={onEditCode}
            style={{
              position: "absolute",
              top: "10",
              right: "35",
              width: "18px",
              fill: "#53bde4",
              cursor: "pointer",
            }}
            title="Edit Code"
          />
          <DeleteIcon
            onClick={(e) => onDelete(data.id)}
            style={{
              position: "absolute",
              top: "10",
              right: "10",
              width: "20px",
              cursor: "pointer",
            }}
          />
        </div>

        <div style={customNodeStyles.inputsBlock}>
          {data.block.deviceTypeId && (
            <div style={customNodeStyles.inputBlock}>
              <label style={customNodeStyles.label}>device</label>
              <select onChange={onDeviceChange} style={customNodeStyles.input}>
                {/* <option disabled selected>Choose device</option> */}
                {devices?.map((device: any, index: any) => (
                  <option
                    key={index}
                    value={device.id}
                    selected={data.block.deviceId == device.id}
                  >
                    {device.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div style={customNodeStyles.inputBlock}>
            {payload.block.inputs.map((item, i) => {
              switch (item.type) {
                case 0:
                  return (
                    <div key={i} style={{ marginBottom: "7px" }}>
                      <label style={customNodeStyles.label}>{item.label}</label>
                      <input
                        type="text"
                        style={customNodeStyles.input}
                        defaultValue={item.value}
                        className="nodrag"
                        data-id={payload.block.id}
                        data-key={item.label}
                        onChange={(e) => onChange(e.target.value, i)}
                      />
                      <ListIcon
                        style={{
                          width: "20px",
                          fill: "#c7c7c7",
                          position: "relative",
                          left: "4",
                          top: "6",
                          cursor: "pointer",
                        }}
                        onClick={onAddVariable}
                      />
                    </div>
                  );
                case 1:
                  return (
                    <div key={i}>
                      <label style={customNodeStyles.label}>{item.label}</label>
                      <select
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          const updatedPayload = { ...payload };
                          updatedPayload.block.inputs[i].value = selectedValue;
                          setPayload(updatedPayload);
                        }}
                        style={customNodeStyles.input}
                        value={payload.block.inputs[i].value}
                      >
                        {models?.map((model: any, y: any) => (
                          <option
                            key={y}
                            value={model.id}
                            selected={item.id == model.id}
                          >
                            {model.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  );
                default:
                  return null;
              }
            })}
          </div>
        </div>
        {data.block.outputs.length > 0 && (
          <div style={{ borderTop: "1px solid #666d6e" }}>
            <label style={customNodeStyles.blockTitle}>Outputs</label>
            <div style={customNodeStyles.scope}>
              {data.block.outputs.map((output, key) => {
                return (
                  <>
                    <label key={key} style={customNodeStyles.label}>
                      {output.label}
                    </label>
                    <div>
                      <AddItemIcon
                        onClick={() => saveToScope(output.label)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        )}
        {modalOpen && (
          <Wizard title="Add variable">
            {UserService.scope.map((item, index) => {
              return <div>{item}</div>;
            })}
          </Wizard>
        )}

        <Handle
          type="source"
          position={Position.Bottom}
          style={customNodeStyles.handleBottomCenter}
        />
      </div>
    </div>
  );
});
